import React from 'react';

import { 
  FooterSection,
  FooterContainer,
  FooterButtons,
  FooterButton,
  FooterLinkButton
} from './style';

const SimpleFooter = () => (
  <FooterSection>
    <FooterContainer>
      <FooterButtons>
        <FooterButton href="https://poqcommerce.com/blog">
          What's New
        </FooterButton>
        <FooterLinkButton to="/support">
          Get Support
        </FooterLinkButton>
      </FooterButtons>
    </FooterContainer>
  </FooterSection>
);

export default SimpleFooter;